import * as Sentry from "@sentry/angular";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";

Sentry.init({
    dsn: "https://7f06d74f28dcd0a41d2c07b67e62c93d@o4509487635103744.ingest.de.sentry.io/4509533135175760",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1
})

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));